import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface UpdateClientLikeRequest {
  clientId: number;
}

export const updateClientLike = ({ clientId }: UpdateClientLikeRequest) => {
  return api.put<ApiResponse<undefined>>('/client/like', {
    clientId,
  });
};

const useUpdateClientLike = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    UpdateClientLikeRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  UpdateClientLikeRequest,
  QueryKey
> => {
  return useMutation(updateClientLike, {
    ...options,
  });
};

export default useUpdateClientLike;
